import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  Switch,
  FormControlLabel,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Col, Row } from "react-bootstrap";
import { PhotoCamera, Visibility, VisibilityOff } from "@mui/icons-material";
import PROFILE_PIC from "../../assets/images/profileImg.png";
import styles from "./addUser.module.scss";
import { Select, MenuItem } from "@mui/material";

import { setCookie } from "../../utils/common/cookies";
import toast from "react-hot-toast";
import { DESTINATIONS } from "../../utils/common/constants";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
import { connect, useDispatch } from "react-redux";
import {
  createUser,
  updateUser,
  updateUserPassword,
  getAllUser,
} from "../../store/actions";
import { useS3Upload } from "../../customHooks/S3Upload";

const leftInputBox = [
  {
    id: 1,
    label: "USERNAME*",
    inputkey: "fullName",
    errorLabel: "Please Enter User Name",
    type: "text",
  },
  // {
  //   id: 2,
  //   label: "USER ID*",
  //   inputkey: "id",
  //   type: "number",
  //   errorLabel: "Please Enter User Id",
  //   maxLength: 10,
  // },
  {
    id: 3,
    label: "EMAIL ID*",
    inputkey: "email",
    type: "email",
    errorLabel: "Please Enter Email",
  },
  {
    id: 4,
    label: "MOBILE NUMBER*",
    inputkey: "phoneNumber",
    errorLabel: "Please enter a valid 10-digit number",
    maxLength: 10,

    type: "number",
  },
  {
    id: 5,
    label: "ROLE*",
    inputkey: "role",
    type: "dropdown",
    errorLabel: "Please select a role",
  },
  // {
  //   id: 6,
  //   label: "STATUS*",
  //   inputkey: "status",
  //   type: "dropdown",
  //   errorLabel: "Please select a status",
  // },
];

const passwordInputData = [
  {
    id: 4,
    label: "Password*",
    inputkey: "password",
    type: "password",
    errorLabel: "Password should be at least 5 Characters",
  },
  {
    id: 5,
    label: "Confirm Password*",
    inputkey: "confirmPassword",
    type: "password",
    width: "120%",
    errorLabel: " Please re-enter your password to confirm",
  },
];

const InitialState = {
  fullName: "",
  phoneNumber: "",
  id: "",
  email: "",
  otp: 123456,
  role: "",
  status: "",
  imageUrl: "",
};

const IntialPasswdState = {
  password: "",
  confirmPassword: "",
};

const passwordInitialState = {
  password: "",
  confirmPassword: "",
  showPassword: false,
};

const roleOptions = [
  { label: "admin", value: "admin" },
  { label: "dispatcher", value: "dispatcher" },
  { label: "packager", value: "packager" },
];

const statusOptions = [
  { label: "1", value: "Active" },
  { label: "0", value: "Inactive" },
];

const AddUser = ({ user = {} }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const [userDetails, setUserDetails] = useState(InitialState);
  const [passwd, setPasswd] = useState(IntialPasswdState);
  const [emailError, setEmailError] = useState("");
  const [images, uploadImages] = useS3Upload();
  const derivedRole = "User";
  const [passwordValues, setPasswordValues] = useState(passwordInitialState);

  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorValues, setErrorValues] = useState({});
  const [originalUserDetails, setOriginalUserDetails] = useState({});

  useEffect(() => {
    if (location?.state === "edit") {
      const originalData = {
        fullName: user?.fullName || "",
        phoneNumber: user?.phoneNumber || "",
        email: user?.email || "",
        role: user?.role || "",
        status: user?.status?.toString() || "",
        imageUrl: user?.imageUrl || "",
      };
      setUserDetails(originalData);
      setOriginalUserDetails(originalData);
    }
  }, []);
  console.log(userDetails, "userDetails");

  // const validateEmail = (email) => {
  //   const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  //   return emailRegex.test(email);
  // };
  const validateEmail = (email) => {
    const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    return emailRegex.test(email?.toLowerCase());
  };

  const handleInputChange = (key, value) => {
    if (/^\d+$/.test(value) && key === "aadharNumber") {
      value = value.slice(0, 12);
    }
    setUserDetails((prevState) => {
      return {
        ...prevState,
        [key]: value,
      };
    });
    handleOnBlur(key, value);
  };

  const handlePasswordInputChange = (key, value) => {
    setPasswordValues((prevState) => {
      return {
        ...prevState,
        [key]: value,
      };
    });
    handleOnBlur(key, value);
  };

  const handleMobileNumber = (key, value) => {
    if (/^\d{0,10}$/.test(value)) {
      handleInputChange(key, value);
    } else {
      // console.log("Error", value);
    }
  };

  // const handleOnBlur = (key = "", value) => {
  //   switch (key) {
  //     case "phoneNumber": {
  //       const result = value?.length === 10;
  //       return handleFeildErrors(key, result);
  //     }
  //     case "fullName": {
  //       const result = value?.length > 2;
  //       return handleFeildErrors(key, result);
  //     }
  //     case "password": {
  //       const result = value?.length >= 1;
  //       return handleFeildErrors(key, result);
  //     }

  //     case "confirmPassword": {
  //       const result = value?.length >= 1 && value === passwordValues?.password;
  //       return handleFeildErrors(key, result);
  //     }
  //     case "email": {
  //       const result = validateEmail(value);
  //       return handleFeildErrors(key, result);
  //     }

  //     default:
  //       return;
  //   }
  // };
  const handleOnBlur = (key, value) => {
    let isValid = true;
    switch (key) {
      case "name":
        isValid = value.length > 2;
        break;
      case "mobileNumber":
        isValid = value.length === 10;
        break;
      case "email":
        isValid = validateEmail(value);
        break;
      case "password":
        isValid = value.length >= 5;
        break;
      case "confirmPassword":
        isValid = value === passwordValues.password;
        break;
      default:
        break;
    }
    setErrorValues((prev) => ({
      ...prev,
      [key]: isValid,
    }));
  };

  const handleFeildErrors = (key, value) => {
    console.log("err", key, value);
    setErrorValues((prevState) => {
      return {
        ...prevState,
        [key]: value,
      };
    });
  };

  const handleFieldChange = (key, value) => {
    switch (key) {
      case "phoneNumber":
        return handleMobileNumber(key, value);
      case "mobileNumber":
        return handleMobileNumber(key, value);
      case "password":
        return handlePasswordInputChange(key, value);
      case "confirmPassword":
        return handlePasswordInputChange(key, value);
      default:
        return handleInputChange(key, value);
    }
  };

  // console.log("loggedInUser", loggedInUser);

  const handleBlur = () => {
    if (!validateEmail(userDetails?.email)) {
      setErrorMessage("Please enter a valid email address");
    } else {
      setErrorMessage(""); // Clear error message if valid
    }
  };

  const handleClickShowPassword = () => {
    handlePasswordInputChange("showPassword", !passwordValues?.showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleUploadFiles = async (e, key, destination) => {
    const files = e.target.files;
    console.log("files", files);
    if (files?.length > 0) {
      const uploadUrl = await uploadImages(key, files[0], destination);
      setUserDetails({
        ...userDetails,
        imageUrl: uploadUrl,
      });
    }
  };

  const onInputChange = (key, value = "") => {
    if (key === "email") {
      setUserDetails({
        ...userDetails,
        [key]: value.toLowerCase(),
      });
    } else {
      setUserDetails({
        ...userDetails,
        [key]: value,
      });
    }
  };
  //  toggle
  const onToggleChange = (key, value = "") => {
    setUserDetails({
      ...userDetails,
      [key]: value,
    });
  };

  const isPasswordSubmitDisabled =
    passwordValues.password.length <= 1 ||
    passwordValues.password !== passwordValues.confirmPassword;

  //   const handleUpdatePassword = () => {
  //     if (!isPasswordSubmitDisabled) {
  //       dispatch(
  //         updateUserPassword({
  //           payload: {
  //             email: loggedInUser?.email,
  //             mobileNumber: loggedInUser?.mobileNumber,
  //             password: passwordValues?.password,
  //           },
  //           callback: {
  //             success: () => logoutPwd(),
  //           },
  //         })
  //       );
  //     }
  //   };

  const handleCancel = () => {
    window.history.go(-1);
  };

  const minValuesEntered =
    userDetails?.aadharNumber?.length < 12 || userDetails?.name?.length < 3;

  const currentDate = new Date();
  const resultDate = currentDate.getTime();

  const handleSubmit = () => {
    const payload = {
      fullName: userDetails?.fullName,
      phoneNumber: userDetails?.phoneNumber,
      email: userDetails?.email,
      password:
        passwordValues?.password?.length > 0
          ? passwordValues?.password
          : user?.password,
      role: userDetails?.role,
      status: Number(userDetails?.status),
      imageUrl: userDetails?.imageUrl,
    };
    console.log("payload add user", payload)

    const payloadPwd = {
      username: userDetails?.phoneNumber,
      password:
        passwordValues?.password?.length > 0
          ? passwordValues?.password
          : user?.password,
    };

    if (location?.state === "edit") {
      dispatch(
        updateUser({
          payload: { ...user, ...payload },
          callback: {
            success: () =>
              dispatch(
                updateUserPassword({
                  payload: payloadPwd,
                  callback: {
                    success: () => {
                      // Refresh the user list so changes show immediately
                      dispatch(getAllUser());
                      navigate(-1);
                    },
                  },
                })
              ),
          },
        })
      );
    } else {
      dispatch(
        createUser({
          payload: payload,
          callback: {
            success: () =>
              dispatch(
                updateUserPassword({
                  payload: payloadPwd,
                  callback: {
                    success: () => {
                      // Refresh the user list to include the new user
                      dispatch(getAllUser());
                      navigate(-1);
                    },
                  },
                })
              ),
          },
        })
      );
    }
  };

  const isAddPasswordValid = () => {
    return (
      passwordValues.password.length >= 1 &&
      passwordValues.confirmPassword === passwordValues.password
    );
  };

  const hasUserDataChanged = () => {
    for (let key in originalUserDetails) {
      if (userDetails[key] !== originalUserDetails[key]) {
        if (passwordValues?.password) {
          isEditPasswordValid();
        } else {
          return true;
        }
      }
    }

    return false;
  };

  const isEditPasswordValid = () => {
    if (passwordValues.password || passwordValues.confirmPassword) {
      return (
        passwordValues.password.length >= 5 &&
        passwordValues.password === passwordValues.confirmPassword
      );
    }
    return false;
  };

  const isAddMode = location?.state !== "edit";

  const isAllFieldsValid = () => {
    const requiredFields = ["fullName", "phoneNumber", "role", "status", "email"];

    for (let field of requiredFields) {
      if (!userDetails[field] || errorValues[field] === false) {
        return false;
      }
    }

    if (userDetails?.email && !validateEmail(userDetails?.email)) {
      return false;
    }

    if (isAddMode) {
      return isAddPasswordValid();
    }

    return hasUserDataChanged() || isEditPasswordValid();
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.title}>
          {location?.state === "edit" ? "EDIT USER" : "ADD USER"}
        </div>
        <Row className={styles.profilePicRow}>
          <Col className={styles.profilePicContainer}>
            <img
              src={userDetails?.imageUrl || PROFILE_PIC}
              alt="profile pic"
              className={styles.profilePic}
            />
          </Col>
          <Col className={styles.profilePicActionContainer}>
            <div className={styles.buttonsContainer}>
              <Button
                variant="contained"
                startIcon={<PhotoCamera />}
                component="label"
                classes={{ contained: styles.button }}
              >
                Upload photo
                <input
                  onChange={(e) =>
                    handleUploadFiles(
                      e,
                      "userImage",
                      DESTINATIONS?.USER_DETAILS
                    )
                  }
                  type="file"
                  accept="image/*"
                  hidden
                />
              </Button>
              {/* <Button
                variant="outlined"
                classes={{ outlined: styles.outlinedButton }}
              >
                {" "}
                reset
              </Button> */}
            </div>
            <div className={styles.picUploadInfo}>
              Allowed PNG or JPEG. Max size of 500KB.
            </div>
          </Col>
        </Row>
        <Paper elevation={2} sx={{ borderRadius: "12px" }}>
          {" "}
          <div className={styles.top}>
            {leftInputBox?.map((item) => (
              <div className={styles.inputWrapper} key={item?.id}>
                <div className={styles.middleWrapper}>
                  {/* <FormControl
                    error={errorValues?.[item?.inputkey] === false}
                    variant="outlined"
                    // focused={true}
                    classes={{ root: styles.inputContainer }}
                    fullWidth
                  > */}
                  <FormControl
                    error={errorValues[item.inputkey] === false}
                    variant="outlined"
                    classes={{ root: styles.inputContainer }}
                  >
                    <InputLabel id={`label-${item.inputkey}`}>
                      {item.label}
                    </InputLabel>
                    {item.type === "dropdown" ? (
                      <Select
                        labelId={`label-${item.inputkey}`}
                        id={`select-${item.inputkey}`}
                        value={userDetails?.[item.inputkey] || ""}
                        onChange={(e) =>
                          handleFieldChange(item.inputkey, e.target.value)
                        }
                        onBlur={() =>
                          handleOnBlur(
                            item.inputkey,
                            userDetails?.[item.inputkey] || ""
                          )
                        }
                        label={item.label}
                        classes={{
                          root: styles.input,
                        }}
                      >
                        {/* {(item.inputkey === "role"
                          ? roleOptions
                          : statusOptions
                        ).map((option) => (
                          <MenuItem key={option.label} value={option.label}>
                            {option.value}
                          </MenuItem>
                        ))} */}
                        {item.inputkey === "role" &&
                          roleOptions.map((option) => (
                            <MenuItem key={option.label} value={option.label}>
                              {option.value}
                            </MenuItem>
                          ))}
                      </Select>
                    ) : (
                      <OutlinedInput
                        id={`outline-input-${item.inputkey}`}
                        type={
                          item.inputkey === "phoneNumber" ? "tel" : item.type
                        }
                        classes={{
                          root: styles.input,
                          input: styles.inputField,
                        }}
                        label={item.label}
                        value={userDetails?.[item.inputkey]}
                        onChange={(e) => {
                          handleFieldChange(item.inputkey, e.target.value);
                        }}
                        inputProps={
                          item.inputkey === "phoneNumber"
                            ? {
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                                maxLength: 10,
                              }
                            : item.maxLength
                            ? { maxLength: item.maxLength }
                            : undefined
                        }
                        onBlur={() =>
                          handleOnBlur(
                            item.inputkey,
                            userDetails?.[item.inputkey] || ""
                          )
                        }
                      />
                    )}

                    {item?.errorLabel && (
                      <FormHelperText
                        classes={{ root: styles.helperText }}
                        htmlFor={`outlined-input-${item?.inputkey}`}
                      >
                        {item?.errorLabel}
                      </FormHelperText>
                    )}
                  </FormControl>
                </div>
              </div>
            ))}

            <FormControl classes={{ root: styles.inputContainer }} fullWidth>
              <FormControlLabel
                control={
                  <Switch
                    checked={Number(userDetails?.status) === 1}
                    onChange={(e) =>
                      onInputChange("status", e.target.checked ? 1 : 0)
                    }
                    color="primary"
                  />
                }
                label={`Status: ${
                  Number(userDetails?.status) === 1 ? "Active" : "Inactive"
                }`}
              />
            </FormControl>
            {/* <Switch
              checked={Number(userDetails?.status) === 1}
              onChange={(e) =>
                onToggleChange("status", e.target.checked ? 1 : 0)
              }
              color="primary"
            /> */}
          </div>
        </Paper>
        <Paper elevation={2} sx={{ borderRadius: "12px" }}>
          {" "}
          <div className={styles.titlePwd}>
            {" "}
            {location?.state === "edit" ? "Edit Password" : "Create Password"}
          </div>
          <div className={styles.passwordContainer}>
            {passwordInputData?.map((item) => (
              <Col className={styles.inputWrapper}>
                <div className={styles.middleWrapper}>
                  {/* <FormControl
                    error={
                      errorValues?.[item?.inputkey] === false ? true : false
                    }
                    variant="outlined"
                    focused={passwordValues?.[item?.inputkey] ? true : false}
                    classes={{ root: styles.inputContainer }}
                    key={item?.id}
                    style={
                      {
                        // marginLeft: item?.aadharNumberLeft && "-820px",
                        // marginTop: item?.aadharNumberLeft && "20px",
                        // width: "100%",
                      }
                    }
                  > */}
                  <FormControl
                    error={errorValues[item.inputkey] === false}
                    variant="outlined"
                    classes={{ root: styles.inputContainer }}
                  >
                    <InputLabel htmlFor={`outline-input-${item?.inputkey}`}>
                      {item?.label}
                    </InputLabel>
                    <OutlinedInput
                      id={`outline-input-${item.inputkey}`}
                      type={
                        passwordValues?.showPassword === true
                          ? "text"
                          : item?.type
                      }
                      classes={{
                        root: styles.input,
                        input: styles.inputField,
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            classes={{ root: styles.eyeButton }}
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            edge="end"
                          >
                            {passwordValues.showPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      label={item?.label}
                      value={passwordValues?.[item?.inputkey] || ""}
                      onChange={(e) => {
                        handleFieldChange(item?.inputkey, e.target.value);
                      }}
                      onBlur={() =>
                        handleOnBlur(
                          item?.inputkey,
                          passwordValues?.[item?.inputkey] || ""
                        )
                      }
                      labelWidth={70} // Optional: sometimes needed in older MUI versions
                      InputLabelProps={{
                        shrink: !!passwordValues?.[item?.inputkey],
                      }}
                    />

                    {item?.errorLabel && (
                      <FormHelperText
                        htmlFor={`outlined-input-${item?.inputkey}`}
                      >
                        {item?.errorLabel}
                      </FormHelperText>
                    )}
                  </FormControl>
                </div>
              </Col>
            ))}
          </div>
        </Paper>

        <div className={styles.buttonContainer}>
          <OutlinedButton
            title={"Cancel"}
            txtClr={"hsla(187, 98%, 16%, 1)"}
            border={"1px solid hsla(187, 98%, 16%, 1)"}
            width={"90px"}
            height={"34px"}
            borderRadius={"12px"}
            onclick={() => navigate(-1)}
          />
          <CustomButton
            title={"Submit"}
            txtClr={"#FFFFFF"}
            background={!isAllFieldsValid() ? "grey" : "hsla(187, 98%, 16%, 1)"}
            width={"90px"}
            height={"34px"}
            borderRadius={"12px"}
            onClick={handleSubmit}
            disabled={!isAllFieldsValid()} // <== THIS DISABLES BUTTON BASED ON FIELD VALIDATION
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => ({
  user: state.user?.user || {},
});

export default connect(mapStateToProps, null)(AddUser);
